/**
 * 使用 storage 存储待发送数据
 *
 * 可能存在网络等原因导致 CLS 发送失败，存储发送数据等待下一次发送
 */
const baseKey = '__CLS_CACHE__';

/**
 * 存储数据
 * @param {Object|Array} data
 */
function save(data) {
  if (!data) {
    return;
  }

  if (!window.localStorage) {
    return;
  }

  try {
    const cache = window.localStorage.getItem(this.key || baseKey);

    let cacheData = cache ? JSON.parse(cache) : [];

    if (Object.prototype.toString.call(data) === '[object Array]') {
      cacheData = cacheData.concat(data);
    } else {
      cacheData.push(data);
    }

    window.localStorage.setItem(this.key || baseKey, JSON.stringify(cacheData));
  } catch (e) {
    console.log('cls cache error: ', e);
  }
}

/**
 * @return {Array} 返回含有待发送数据的数组
 */
function get() {
  if (!window.localStorage) {
    return [];
  }

  let cacheData = [];
  try {
    const cache = window.localStorage.getItem(this.key || baseKey);

    cacheData = cache ? JSON.parse(cache) : [];
  } catch (e) {
    console.log('cls cache error: ', e);
  }

  return cacheData;
}

/**
 * 清空数据
 */
function clean() {
  if (!window.localStorage) {
    return;
  }

  window.localStorage.setItem(this.key || baseKey, '');
}

function Store(name) {
  this.key = `${baseKey}${name}`;
}

Store.prototype = {
  save,
  get,
  clean,
};

export default Store;
